import { useEffect, useState } from "react";
import Layout from "../../components/layout";
import { useParams } from "react-router-dom";
import QRcode from "qrcode.react";
import { pdf } from "@react-pdf/renderer";
import PdfCreate from "../../components/pdfCreate";
import { saveAs } from "file-saver";
import { certificateService } from "../../api/certificate";

export default function CertificateForceFreeDownload() {
  const { certCode } = useParams();

  const [certificate, setCertificate] = useState(false);

  const getCertificateInfo = async (code) => {
    certificateService
      .loadCertByCodeUnLogged({ verify: code })
      .then((response) => {
        generatePDFDocument(response?.data?.payload[0] || null);
      })
      .catch((error) => {});
  }; //getCertificateInfo

  const generatePDFDocument = async (item) => {
    const data = {
      item: { ...item },
    };

    let base64Image = document.getElementById("qrcode").toDataURL();
    if (base64Image) {
      const blob = await pdf(
        <PdfCreate qrcode={base64Image} data={data} />
      ).toBlob();
      saveAs(
        blob,
        "certificato-haccp-" + item?.name + "-" + item?.surname + "-" + item?.fiscalCode + "-" + item?.releasedAt?.substring(0, 10)
      );
    }
  }; //generatePDFDocument

  useEffect(() => {
    if (certCode) {
      setCertificate(certCode);
      getCertificateInfo(certCode);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certCode]);

  //--- --- ---

  return (
    <Layout>
      <div className="container mx-auto text-center p-4">
        Download Attestato...
        <div style={{ display: "none" }}>
          <QRcode
            value={"https://app.labmar.it/verifyQrCode?verify=" + certificate}
            id="qrcode"
          />
        </div>
      </div>
    </Layout>
  );
}
